//服务器接口
let ip = ''; //process.env.VUE_APP_BASE_URL
let _port = location.port + "";
let isSpecial = ~_port.indexOf("1818") ? true :false;

let newPort = !isSpecial ? 80 : 18180;
try {
  /* eslint-disable */
  ip = 'http://' + /([0-9]{1,3}(\.[0-9]{1,3}){3})/.exec(FingerprintObj.getLocalIp())[0] + ":" + newPort + '/';
} catch (err) {
  ip = location.protocol + "//" + location.hostname + ":" + newPort + "/";
} finally {
  if (location.hostname == 'localhost') {
    ip = 'http://127.0.0.1' + ":" + newPort + "/";
  }
}

// ip = "http://cp2.zhixinxinli888.com/";
// ip = "http://192.168.2.26/";

//图片
const iconPic = {
  // 是否选中
  yesSelect: require('./assets/img/userAdmin/yesSelect.png'),
  noSelect: require('./assets/img/userAdmin/noSelect.png'),
  // 功能键
  into: require('@/assets/img/home/into.png'),
  keyboard: require('@/assets/img/home/keyboard.png'),
  bear: require('@/assets/img/home/bear.png'),
  offsys: require('@/assets/img/home/offsys.png'),
  scale: require('@/assets/img/home/scale.png'),
  scales: require('@/assets/img/home/scales.png'),
  small: require('@/assets/img/home/small.png'),
};

export default {
  ip,
  iconPic,
};
